<template>
  <div class="user_info_box">
    <div class="section fill">
      <div class="inner">
        <!-- 개인정보수정 -->
        <div class="info_box_box">
          <div v-if="getAccount" class="user_info">
            <p class="user_name">
              <em>{{ getAccount.name }} </em> {{ $t('library.sidebar.nim') }}
            </p>
            <!-- <p class="user_id">{{ getAccount.username }}</p> -->
          </div>
          <div class="head_coupon">
            <h4>쿠폰</h4>
            <p>
              <b>{{ getAccountDiscountsCount }}</b>
              장
            </p>
          </div>
          <div class="btn_wrap">
            <router-link :to="{ name: 'login_to_edit' }" class="box_btn">
              <span class="an_t scope_style">정보수정</span>
            </router-link>
            <a class="box_btn line" href="#" @click="logout">
              <span class="an_t scope_style">로그아웃</span>
            </a>
          </div>
        </div>

        <!-- 마이페이지 메뉴 -->
        <div class="mypage_menu">
          <ul>
            <li>
              <router-link
                :to="{ name: 'orders' }"
                :class="
                  currentTab === 'orders' || $route.name === 'orders'
                    ? 'active'
                    : ''
                "
              >
                구매 내역
              </router-link>
            </li>
            <!-- <li>
              <router-link
                :to="{ name: 'reviews' }"
                :class="
                  $route.name === 'reviews' || currentTab === 'reviews'
                    ? 'active'
                    : ''
                "
                >{{ $t('member.accounthead.5887') }}</router-link
              >
            </li> -->
            <!-- 선물 주석 -->
            <!-- <template>
              <li>
                <router-link
                  :to="{ name: 'gift' }"
                  :class="
                    $route.name === 'gift' || currentTab === 'gift'
                      ? 'active'
                      : ''
                  "
                  >선물받기</router-link
                >
              </li>
            </template> -->
            <!-- 증정 주석 -->
            <!-- <template>
              <li>
                <router-link
                  :to="{ name: 'coupon' }"
                  :class="
                    $route.name === 'coupon' || currentTab === 'coupon'
                      ? 'active'
                      : ''
                  "
                  >도서 쿠폰 입력</router-link
                >
              </li>
            </template> -->
            <!-- 할인 쿠폰 주석 -->
            <li>
              <router-link
                :to="{ name: 'discount' }"
                :class="
                  $route.name === 'discount' || currentTab === 'discount'
                    ? 'active'
                    : ''
                "
              >
                쿠폰 등록
              </router-link>
            </li>
            <li>
              <router-link
                :to="{ name: 'returns' }"
                :class="
                  $route.name === 'returns' || currentTab === 'returns'
                    ? 'active'
                    : ''
                "
              >
                취소 내역
              </router-link>
            </li>
            <!-- 체험판 -->
            <li>
              <router-link
                :to="{ name: 'coupon' }"
                :class="
                  $route.name === 'coupon' || currentTab === 'coupon'
                    ? 'active'
                    : ''
                "
              >
                체험판 / 선물 등록
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import {
  AUTH_LOGOUT,
  ACCOUNT_GET_INFO,
  ACCOUNT_DISCOUNT_GET_LIST
} from '@/store/types'

import { isNiaMode, isCoupon } from '@/store/constants'

export default {
  name: 'AccountHead',
  props: {
    // eslint-disable-next-line vue/require-default-prop
    currentTab: {
      type: String
    }
  },
  data() {
    return {
      isNiaMode,
      isCoupon
    }
  },
  computed: {
    ...mapGetters(['getCurrentUser', 'getAccount', 'getAccountDiscountsCount'])
  },
  mounted() {
    if (!this.getAccount) {
      this.$store.dispatch(ACCOUNT_GET_INFO)
    }
    if (!this.getAccountDiscountsCount) {
      this.$store.dispatch(ACCOUNT_DISCOUNT_GET_LIST)
    }
  },
  methods: {
    async logout() {
      await this.$store.dispatch(AUTH_LOGOUT)
      // this.$store.reset()
      // this.$router.go(this.$route.currentRoute)
      this.$router.push({ name: 'store' })
    }
  }
}
</script>
<style src="@/assets/css/page_member.css" scoped></style>
<style src="@/assets/css/page_join.css" scoped></style>
<style lang="scss" scoped>
.user_info_box {
  border-bottom: 1px solid #d6e7f1;
  .info_box_box {
    max-width: 660px;
    width: fit-content;
    min-width: 620px;
    background-color: #008df3;
    margin: 30px auto;
    color: #fff;
    border-radius: 20px;
    padding: 20px;
  }
  .inner .info_box_box > div {
    display: inline-block;
    padding: 0 20px;
    vertical-align: middle;
  }

  .info_box_box .user_info {
    padding-top: 0;
  }

  .user_info .user_name {
    color: #fff;
    text-align: left;
    font-size: 33px;
    letter-spacing: 0.5px;
  }

  .user_info .user_id {
    color: #e5e5e5;
    font-size: 16px;
    margin-top: 5px;
    letter-spacing: 0.5px;
  }

  .head_coupon {
    border-right: 1px solid #fff;
    border-left: 1px solid #fff;
    padding-right: 100px !important;
    h4 {
      font-size: 25px;
      margin-bottom: 5px;
    }
    p {
      font-size: 25px;
      b {
        font-size: 30px;
      }
    }
  }

  .btn_wrap {
    margin-top: 12px;
  }
  .btn_wrap a {
    display: block;
    background-color: #fff;
    border: none;
    border-radius: 5px;
    padding: 0 30px;
    margin-bottom: 10px;
    height: 25px;
  }

  .btn_wrap span {
    &.scope_style {
      color: #008df3;
      font-size: 14px;
      line-height: 25px;
    }
  }
}
@media screen and (max-width: 650px) {
  .user_info_box {
    .info_box_box {
      min-width: unset;
      width: 95%;
      padding: 10px 0;
      .user_info .user_name {
        font-size: 25px;
      }

      .user_info .user_id {
        font-size: 12px;
        margin-top: 0;
      }

      .head_coupon {
        padding-right: 50px !important;
        h4 {
          font-size: 20px;
          margin-bottom: 5px;
        }
        p {
          font-size: 20px;
          b {
            font-size: 25px;
          }
        }
      }
      .btn_wrap a {
        padding: 0 20px;
        margin-bottom: 8px;
      }

      .btn_wrap span {
        font-size: 13px;
      }
    }
  }
}

@media screen and (max-width: 465px) {
  .user_info_box {
    .info_box_box {
      width: 95%;
      padding: 5px 0;
      .user_info .user_name {
        font-size: 20px;
      }
      .head_coupon {
        padding-right: 25px !important;
        h4 {
          font-size: 18px;
          margin-bottom: 5px;
        }
        p {
          font-size: 18px;
          b {
            font-size: 23px;
          }
        }
      }
      .btn_wrap a {
        padding: 0 15px;
      }

      .btn_wrap span {
        font-size: 13px;
      }
    }
    .inner .info_box_box > div {
      padding: 0 10px;
    }
  }
}
</style>
